import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, computed, watch } from "vue";
import { useStore } from "@/store";
import { generate } from "@ant-design/colors";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ColorPicker',
    props: {
        bindValue: {
            type: String,
            required: true,
        },
    },
    emits: ["update:bind-value"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        // ColorPicker
        var props = __props;
        var store = useStore();
        var colorPickerRef = ref();
        var emit = __emit;
        // 所选颜色 自定义
        // const selectedColor = window.themeColor;
        var selectedColor = ref(props.bindValue);
        // 所选颜色的前后各4个渐变色
        var gradientSelectedColorSwatches = computed(function () {
            var gradientSelectedColors = generate(selectedColor.value);
            return gradientSelectedColors
                .slice(1, 5)
                .concat(gradientSelectedColors.slice(6, 10));
        });
        watch(function () { return selectedColor.value; }, function (newValue) {
            // 当 bindValue 发生变化时，触发 update:bind-value 事件
            emit("update:bind-value", newValue); // 双向绑定受控，发送事件使得传来的值能发生变化
        });
        watch(function () { return props.bindValue; }, function (newValue) {
            selectedColor.value = newValue;
            window.setThemeColor(newValue);
        });
        // 备选16色
        var alternativeSwatches = ref([
            "#3B82F6",
            "#6366F1",
            "#8B5CF6",
            "#A855F7",
            "#0EA5E9",
            "#06B6D4",
            "#F43F5E",
            "#EF4444",
            "#EC4899",
            "#D946EF",
            "#F97316",
            "#F59E0B",
            "#EAB308",
            "#84CC16",
            "#22C55E",
            "#10B981",
        ]);
        var handleColorChange = function (color) {
            window.setThemeColor(color);
        };
        var handleColorClear = function () {
            var defaultColor = getComputedStyle(document.documentElement).getPropertyValue("--theme-color-default");
            window.setThemeColor(defaultColor);
            selectedColor.value = defaultColor;
        };
        return function (_ctx, _cache) {
            var _component_n_color_picker = _resolveComponent("n-color-picker");
            return (_openBlock(), _createBlock(_component_n_color_picker, {
                ref_key: "colorPickerRef",
                ref: colorPickerRef,
                class: "head-color-picker",
                value: selectedColor.value,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) { return ((selectedColor).value = $event); }),
                "default-color": selectedColor.value,
                "on-update": handleColorChange,
                "on-clear": handleColorClear,
                "show-alpha": false,
                modes: ['hex'],
                actions: ['clear'],
                swatches: alternativeSwatches.value.concat(_unref(gradientSelectedColorSwatches))
            }, null, 8, ["value", "default-color", "swatches"]));
        };
    }
});
